import { Component, OnInit, inject } from '@angular/core';
import {FormGroup, Validators, FormControl, FormBuilder, ReactiveFormsModule} from '@angular/forms';
import { ButtonSize, ButtonState, ButtonType, InputSize, InputState } from '../../../../../../assets/types/dtoTypes';
import { passwordStrengthValidator } from '../../../../../shared/validators/validators';
import { RegistrationPageService } from '../../registration-page.service';
import {InputComponent} from "../../../../../shared/input/input.component";
import {TranslateModule} from "@ngx-translate/core";
import {ButtonComponent} from "../../../../../shared/button/button.component";
import {MatError} from "@angular/material/select";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-password-form',
  templateUrl: './password-form.component.html',
  styleUrls: ['./password-form.component.scss'],
  imports: [
    ReactiveFormsModule,
    InputComponent,
    TranslateModule,
    MatError,
    ButtonComponent,
    NgIf
  ],
  standalone: true
})
export class PasswordFormComponent implements OnInit {
  private registrationPageService = inject(RegistrationPageService);
  private fb = inject(FormBuilder);


  registerForm!: FormGroup;

  protected readonly ButtonSize = ButtonSize;

  protected readonly ButtonState = ButtonState;

  protected readonly ButtonType = ButtonType;

  protected readonly InputSize = InputSize;

  protected readonly InputState = InputState;

  constructor() {
  }

  ngOnInit() {

    this.registerForm = this.fb.group( {
      password: new FormControl( '', [ Validators.required, passwordStrengthValidator() ] ),
    } );
  }

  isValidPassword() {
    const passwordControl = this.registerForm.get( 'password' );
    return passwordControl && passwordControl.valid;
  }


  continue() {
    const password = this.registerForm.get( 'password' ).value;
    this.registrationPageService.sendPassword( password );
  }

  back() {
    this.registrationPageService.openForm( 'password_form_back' );
  }
}
